export default __webpack_public_path__ + "433287a115498d3d32d17c397da2e4b1.ttf";